import React, {useRef} from 'react';
import SignaturePad from "react-signature-pad-wrapper";

const CustomerSignatureModal = (props) => {
    const ref = useRef();

    function captureSignature() {
        if (ref.current) {
            const image_url = ref.current.toDataURL();
            props.setJob(previousState => {
                return {...previousState, content: {
                    ...previousState.content,
                    signature: image_url
                }}
            });
        }
        props.close();
    }

    return (
        <div className="modal d-block bg-dark bg-opacity-50" tabIndex="-1" role="dialog" aria-hidden="true">
            <div className="modal-dialog mw-80 modal-dialog-scrollable modal-entrance">
                <div className="modal-content w-80 h-auto m-auto bg-light">
                    <div className="modal-header d-block p-3">
                        <div className="d-flex">
                            <h3 className="text-xl font-semibold text-gray-900 dark:text-white">Confirm pickup</h3>
                            <button onClick={() => props.onClose()}
                                    className="border border-0 text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white">
                                <i className="bi bi-x-lg text-secondary-emphasis" />
                                <span className="sr-only">Close modal</span>
                            </button>
                        </div>
                    </div>

                    <div className="modal-body w-95 m-auto" style={{overflowY: "scroll", minHeight: "400px"}}>
                        <div className="lead fs-16 mb-2">Signature / Initials</div>
                        <div className="border border-2 m-auto">
                            <SignaturePad ref={ref} options={{minWidth: 5}} height={400} />
                        </div>
                    </div>

                    <div className="modal-footer justify-content-start items-center p-4 md:p-5 border-t border-gray-200 rounded-b dark:border-gray-600">
                        <button className="btn btn-primary bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800" onClick={() => captureSignature()}>Save</button>
                        <button
                            className="btn text-secondary-emphasis border border-secondary-subtle bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
                            onClick={() => props.onClose()}>Close
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CustomerSignatureModal;